import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { fetchConfig, schemas } from './config/fetchConfig.js'
import staticData from './config/static.js'
import pageContentElements from './config/page-content-elements.js'
import navigation from './config/navigation.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Config imports
    fetchConfig,
    schemas,
    pageContentElements,
    navigation,
    static: staticData,
    // End config imports
    contentData: {},
    modalState: false,
    currModalImage: {},
    editMode: false,
    enableEditCode: 'Erich2020',
    currentRoute: {},
    mediaObjectColumnExtended: 0,
    videoDisplayMode: 'low',
    boltApi: process.env.VUE_APP_BOLT_API,
    boltBackend: process.env.VUE_APP_BOLT_BE,
    boltLoginStatus: 0,
    config: {
      sliderFormate: {
        hochformat: 1.33,
        buch: 1.45,
        querformat: 0.66,
        quadratisch: 1
      }
    },
    homeData: {},
    currentPage: '',
    pagesData: {},
    footerData: {},
    subjectsData: {},
    subsubjectsData: {},
    allSubsubjectsData: {},
    mediaObjectsData: {},
    objectsData: {},
    currentObject: '',
    allMediaObjectsData: {},
    allMediaObjectsLoaded: false,
    allLibraryObjectsData: {},
    allLibraryObjectsLoaded: false,
    dossiersData: [],
    dossiersSubSubs: [],
    slidersData: {},
    ethnosData: {},
    ethnoGroupsData: {},
    dlSectionsData: {},
    boltPublicationsEP: '',
    pubIDs: [],
    boltMediaObjectsEP: '',
    mediaObjectsArray: [],
    boltSlidersEP: '',
    slidersArray: [],
    subSubjectsIDs: [],
    boltSubSubjectsEP: '',
    subjectData: {},
    dossierData: {},
    dossierDataRelDos: {},
    publicationData: {},
    ethnieData: {},
    dlPageData: {},
    collectionsPageData: {}, 
    dlSectionData: {},
    dlSectionDataPubList: {},
    dlSectionDataFeaturedPubList: {},
    subjectsPageData: {},
    videosPageData: {},
    ethnographicaPageData: {},
    fotosPageData: {},
    booksPageData: {},
    autographsPageData: {},
    digLibPageData: {},
    divDigPageData: {},
    dossiersPageData: {},
    contentParts: {},
    lang: 'de',
    langs: ['de', 'en', 'ru']
  },
  getters: {
    modalState (state) {
      return state.modalState
    },
    currModalImage (state) {
      return state.currModalImage
    },
    getEditMode (state) {
      return state.editMode
    },
    getNewRoute (state) {
      const newRoute = state.currentRoute.main + state.currentRoute.lang
      return newRoute
    },
    getContentParts (state) {
      return state.contentParts[state.lang]
    },
    getBoltBE (state) {
      return state.boltBackend
    },
    getBoltLoginStatus (state) {
      return state.boltLoginStatus
    },
    getLanguage (state) {
      return state.lang
    },
    getLanguages (state) {
      return state.langs
    },
    getStaticData (state) {
      if (state.lang === 'de') {
        return state.static.de
      }
      if (state.lang === 'en') {
        return state.static.en
      }
      if (state.lang === 'ru') {
        return state.static.ru
      }
    },
    getNavigation (state) {
      return state.navigation
    },
    getHomeData (state) {
      return state.homeData[state.lang] || {}
    },
    getPageData (state) {
      return function (page) {
        if (state.pagesData[state.lang]) {
          return state.pagesData[state.lang].filter(p => {
            return p.slug === page
          })
        }
      }
    },
    getPageStoreData (state) {
      let pdata = {}
      if (state.pagesData[state.lang]) {
        pdata = state.pagesData[state.lang].find(p => {
          return p.slug === state.currentPage
        })
      }
      return pdata
    },
    getSubjectsData (state) {
      if (state.subjectsData[state.lang]) {
        return state.subjectsData[state.lang].filter(subj => subj.einzelthema !== 'Einzelthema')
      }
    },
    getSpecialSubjectsData (state) {
      if (state.subjectsData[state.lang]) {
        return state.subjectsData[state.lang].filter(subj => subj.einzelthema === 'Einzelthema')
      }
    },
    getEthnosData (state) {
      return state.ethnosData[state.lang] || []
    },
    getEthnoGroupsData (state) {
      return state.ethnoGroupsData[state.lang]
    },
    getEthnoGroupDataForGroup (state) {
      return function (group) {
        let ethnos = []
        for (let j = 0; j < group.length; j++) {
          for (let i = 0; i < state.ethnosData[state.lang].length; i++) {
            if (state.ethnosData[state.lang][i].id === group[j].id) {
              ethnos.push(state.ethnosData[state.lang][i])
            }
          }
        }
        ethnos.sort((a, b) => a.kennnummer - b.kennnummer)
        return ethnos
      }
    },
    getEthnoData (state) {
      return 'Daten für die Ethnie:' + state.ethnieData
    },
    getSubsubjectsData (state) {
      return state.subsubjectsData[state.lang] || []
    },
    getAllSubsubjectsData (state) {
      return state.allSubsubjectsData[state.lang] || []
    },
    getMediaObjectsData (state) {
      return state.mediaObjectsData[state.lang] || []
    },
    getAllMediaObjectsData (state) {
      return state.allMediaObjectsData[state.lang] || []
    },
    getAllLibraryObjectsData (state) {
      return state.allLibraryObjectsData[state.lang] || []
    },
    getDossierVideos (state) {
      return function (ids) {
        if (ids) {
          return ids
        }
      }
    },
    getAllVideosData (state) {
      const mos = state.allMediaObjectsData[state.lang] || []
      const video = mo => {
        return mo.video_self || mo.video_platform
      }
      let allVideos = mos.filter(video)
      return allVideos
      // return state.allMediaObjectsData[state.lang] || []
    },
    getAllVideosDataPaginated (state) {
      const mos = state.allMediaObjectsData[state.lang] || []
      const video = mo => {
        return mo.video_self
      }
      const paginate = function (arr, pageSize) {
        arr.forEach((video, index) => {
          let i = index + 1
          video.page = Math.ceil(i / pageSize)
        })
        return arr
      }
      let allVideos = mos.filter(video)
      let allVideosPaginated = paginate(allVideos, 9)
      return allVideosPaginated
      // return state.allMediaObjectsData[state.lang] || []
    },
    getAllEmbeddedVideosData (state) {
      const mos = state.allMediaObjectsData[state.lang] || []
      const videos = mos.filter(mo => {
        return Object.entries(mo.video_platform).length
      })
        .filter(v => {
          return typeof v.video_platform !== 'undefined' && v.rubrik_sammlung === 'Videos'
        })

      return videos
    },
    getAllEthnographicaData (state) {
      const mos = state.allMediaObjectsData[state.lang] || []
      const ethnographica = mos.filter(mo => mo.rubrik_sammlung === 'Ethnographica')
      return ethnographica
    },
    getAllFotosData (state) {
      const mos = state.allMediaObjectsData[state.lang] || []
      const fotos = mos.filter(mo => mo.rubrik_sammlung === 'Fotos')
      return fotos
    },
    getAllBooksData (state) {
      const bObjs = state.allLibraryObjectsData[state.lang] || []
      const books = bObjs.filter(bObj => bObj.rubrik_bibliothek === 'Bücher')
      return books
    },
    getAllAutographsData (state) {
      const bObjs = state.allLibraryObjectsData[state.lang] || []
      const autographs = bObjs.filter(bObj => bObj.rubrik_bibliothek === 'Autographen')
      return autographs
    },
    getAllDigBibData (state) {
      const objs = state.allLibraryObjectsData[state.lang] || []
      const digBibs = objs.filter(obj => obj.rubrik_bibliothek === 'digitale Bibliothek')
      return digBibs
    },
    getAllDivDigData (state) {
      const objs = state.allLibraryObjectsData[state.lang] || []
      const divDigs = objs.filter(obj => obj.rubrik_bibliothek === 'weitere Digitalisate')
      return divDigs
    },
    getFotosSubSubjects (state) {
      const mos = state.allMediaObjectsData[state.lang] || []
      const fotos = mos.filter(mo => mo.rubrik_sammlung === 'Fotos')
      const fotosWithSubs = fotos.filter(f => {
        return f.subs && f.subs.length
      })
      let subs = []
      fotosWithSubs.forEach(fws => {
        fws.subs.forEach(s => {
          subs.push(s)
        })
      })
      let subsUniqueIds = Array.from(new Set(subs))
      return subsUniqueIds
    },
    getBooksSubSubjects (state) {
      const bObjs = state.allLibraryObjectsData[state.lang] || []
      const books = bObjs.filter(bObj => bObj.rubrik_bibliothek === 'Bücher')
      const booksWithSubs = books.filter(b => {
        return b.subs && b.subs.length
      })
      let subs = []
      booksWithSubs.forEach(bws => {
        bws.subs.forEach(s => {
          subs.push(s)
        })
      })
      let subsUniqueIds = Array.from(new Set(subs))
      return subsUniqueIds
    },
    getAutographsSubSubjects (state) {
      const bObjs = state.allLibraryObjectsData[state.lang] || []
      const autographs = bObjs.filter(bObj => bObj.rubrik_bibliothek === 'Autographen')
      const autographsWithSubs = autographs.filter(b => {
        return b.subs && b.subs.length
      })
      let subs = []
      autographsWithSubs.forEach(aws => {
        aws.subs.forEach(s => {
          subs.push(s)
        })
      })
      let subsUniqueIds = Array.from(new Set(subs))
      return subsUniqueIds
    },
    getDigBibsSubSubjects (state) {
      const bObjs = state.allLibraryObjectsData[state.lang] || []
      const items = bObjs.filter(bObj => bObj.rubrik_bibliothek === 'digitale Bibliothek')
      const itemsWithSubs = items.filter(item => {
        return item.subs && item.subs.length
      })
      let subs = []
      itemsWithSubs.forEach(iws => {
        iws.subs.forEach(s => {
          subs.push(s)
        })
      })
      let subsUniqueIds = Array.from(new Set(subs))
      return subsUniqueIds
    },
    getDivDigsSubSubjects (state) {
      const bObjs = state.allLibraryObjectsData[state.lang] || []
      const items = bObjs.filter(bObj => bObj.rubrik_bibliothek === 'weitere Digitalisate')
      const itemsWithSubs = items.filter(item => {
        return item.subs && item.subs.length
      })
      let subs = []
      itemsWithSubs.forEach(iws => {
        iws.subs.forEach(s => {
          subs.push(s)
        })
      })
      let subsUniqueIds = Array.from(new Set(subs))
      return subsUniqueIds
    },
    getDossiersSubSubjects (state) {
      return state.dossiersSubSubs
    },
    getVideoDisplayMode (state) {
      return state.videoDisplayMode
    },
    getSlidersData (state) {
      return state.slidersData[state.lang] || []
    },
    getDLSectionsData (state) {
      if (state.dlSectionsData[state.lang]) {
        return state.dlSectionsData[state.lang]
      }
    },
    getDLSectionData (state) {
      if (state.dlSectionData[state.lang]) {
        return state.dlSectionData[state.lang]
      }
    },
    getDLSectionDataPubList (state) {
      if (state.dlSectionDataPubList[state.lang]) {
        const listWithPrio = state.dlSectionDataPubList[state.lang]
          .filter(entry => entry.featured_sort > 0)
          .sort((a,b) => {
            if(a.featured_sort < b.featured_sort) return -1
            if(a.featured_sort > b.featured_sort) return 1
            if(a.featured_sort === b.featured_sort) return 0
          })
        const listWithoutPrio = state.dlSectionDataPubList[state.lang]
          .filter(entry => entry.featured_sort === '0')
        
        return [...listWithPrio, ...listWithoutPrio]
          
      }
    },
    getDLSectionDataFeaturedPubList (state) {
      if (state.dlSectionDataFeaturedPubList[state.lang]) {
        const featured = state.dlSectionDataFeaturedPubList[state.lang]
        const featuredSorted = featured.sort((a, b) => a.featured_sort - b.featured_sort)
        return featuredSorted
      }
    },
    getSubjectData (state) {
      return state.subjectData[state.lang] || {}
    },
    getDossierData (state) {
      return state.dossierData[state.lang] || {}
    },
    getDossiersData (state) {
      return state.dossiersData[state.lang]
    },
    getRelDos (state) {
      return state.dossierDataRelDos[state.lang]
    },
    getSingleObjectData (state) {
      let currObj = {}
      if (state.objectsData[state.lang]) {
        currObj = state.objectsData[state.lang].filter(obj => {
          return obj.slug === state.currentObject
        })
      }
      return currObj[0]
    },
    getSingleObjectMediaData (state) {
      if (state.mediaObjectsData && state.objectsData && state.objectsData[state.lang]) {
        let currObj = state.objectsData[state.lang].filter(obj => {
          return obj.slug === state.currentObject
        })
        // let objectMedia = currObj[0].moIds
        let medien = {}
        let medienGesamt = []
        if (state.allMediaObjectsData[state.lang] && currObj[0]) {
          medienGesamt = state.allMediaObjectsData[state.lang].filter(m => {
            return currObj[0].moIds.indexOf(m.id) !== -1
          })
          medien.bilder = medienGesamt.filter(m => {
            return m.symbolbild && !m.video_self
          })
          medien.videos = medienGesamt.filter(m => {
            return m.video_self
          })
        }
        return medien
      }
    },
    getPublicationData (state) {
      return state.publicationData[state.lang]
    },
    getDLPageData (state) {
      if (state.dlPageData[state.lang]) {
        return state.dlPageData[state.lang][0]
      }
    },
    getCollectionsPageData (state) {
      if (state.collectionsPageData[state.lang]) {
        return state.collectionsPageData[state.lang][0]
      }
    },
    getFooterData (state) {
      if (state.footerData[state.lang]) {
        return state.footerData[state.lang][0]
      }
    },
    getSubjectsPageData (state) {
      if (state.subjectsPageData[state.lang]) {
        return state.subjectsPageData[state.lang][0]
      }
    },
    getPageContentElements (state) {
      return function (page) {
        return state.pageContentElements[page][state.lang]
      }
    },
    getAllVideosPageData (state) {
      if (state.videosPageData[state.lang]) {
        return state.videosPageData[state.lang][0]
      }
    },
    getAllEthnographicaPageData (state) {
      if (state.ethnographicaPageData[state.lang]) {
        return state.ethnographicaPageData[state.lang][0]
      }
    },
    getAllFotosPageData (state) {
      if (state.fotosPageData[state.lang]) {
        return state.fotosPageData[state.lang][0]
      }
    },
    getAllBooksPageData (state) {
      if (state.booksPageData[state.lang]) {
        return state.booksPageData[state.lang][0]
      }
    },
    getAllAutographsPageData (state) {
      if (state.autographsPageData[state.lang]) {
        return state.autographsPageData[state.lang][0]
      }
    },
    getAllDigLibPageData (state) {
      if (state.digLibPageData[state.lang]) {
        return state.digLibPageData[state.lang][0]
      }
    },
    getAllDivDigPageData (state) {
      if (state.divDigPageData[state.lang]) {
        return state.divDigPageData[state.lang][0]
      }
    },
    getDossiersPageData (state) {
      if (state.dossiersPageData[state.lang]) {
        return state.dossiersPageData[state.lang][0]
      }
    },
    getNavTitles (state) {
      let navTitles = []
      let staticNavObjects = []
      let navigationArray = Object.entries(state.navigation)
      navigationArray.forEach(n => {
        let naobj = {}
        naobj.slug = n[1].slug
        naobj.navTitel = n[1].navTitle ? n[1].navTitle[state.lang] : null
        staticNavObjects.push(naobj)
      })
      let pages = []
      if (state.pagesData && state.pagesData[state.lang]) {
        pages = state.pagesData[state.lang].map(page => {
          let obj = {}
          obj.slug = page.slug
          obj.navTitel = page.navTitel
          return obj
        })
        navTitles = pages.concat(staticNavObjects)
      }
      return navTitles
    }
  },
  mutations: {
    setBoltHomeData (state, payload) {
      const langs = state.langs
      const homeData = {}

      langs.forEach(lang => {
        const langSuffix = lang === 'de' ? '' : `_${lang}`
        homeData[lang] = {};
        ['einleitung', 'themenintro', 'ethnienintro', 'rubriken'].forEach(field => { homeData[lang][field] = payload[`${field}${langSuffix}`] });
        ['headerbild', 'dhnlogo', 'themenbild', 'ethnografienbild'].forEach(field => { homeData[lang][field] = payload[field].url })
      })

      state.homeData = homeData
    },
    setBoltSubjectsData (state, payload) {
      const langs = state.langs
      const subjectsData = {}

      langs.forEach(lang => {
        subjectsData[lang] = []
      })
      payload.forEach(s => {
        const attrs = s.attributes
        langs.forEach(lang => {
          const subject = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          subject.symbolbild = attrs.symbolbild.url
          subject.slug = attrs.slug
          subject.einzelthema = attrs.einzelthema
          subject.titel = attrs[`titel${langSuffix}`]
          subject.titelNichtVerwenden = attrs.titel_nicht_verwenden
          subject.kurztext = attrs[`kurztext${langSuffix}`]
          subjectsData[lang].push(subject)
        })
      })
      state.subjectsData = subjectsData
    },
    setBoltEthnosData (state, payload) {
      const langs = state.langs
      const ethnosData = {}

      langs.forEach(lang => {
        ethnosData[lang] = []
      })
      payload.forEach(e => {
        const attrs = e.attributes
        langs.forEach(lang => {
          const ethno = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          ethno.id = e.id
          ethno.nurName = attrs.nur_name
          ethno.kachelbild = attrs.kachelbild.url
          ethno.symbolbild = attrs.symbolbild.url
          ethno.kennnummer = attrs.kennnummer
          ethno.slug = attrs.slug
          ethno.titel = attrs[`titel${langSuffix}`]
          ethno.kurztext = attrs[`kurztext${langSuffix}`]
          ethno.ethnientext = attrs[`ethnientext${langSuffix}`]
          ethnosData[lang].push(ethno)
        })
      })
      state.ethnosData = ethnosData
    },
    setBoltSubsubjectsData (state, payload) {
      const langs = state.langs
      const subsubjectsData = {}

      langs.forEach(lang => {
        subsubjectsData[lang] = []
      })
      payload.forEach(ss => {
        const attrs = ss.attributes
        langs.forEach(lang => {
          const subsubject = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          subsubject.symbolbild = attrs.symbolbild.url
          subsubject.slug = attrs.slug
          subsubject.titel = attrs[`titel${langSuffix}`]
          subsubject.titelNichtVerwenden = attrs.titel_nicht_verwenden
          subsubject.pageOrder = parseInt(attrs.page_order)
          subsubject.kurztext = attrs[`kurztext${langSuffix}`]
          subsubjectsData[lang]
            .push(subsubject)
        })
        langs.forEach(lang => {
          subsubjectsData[lang].sort((a, b) => {
            if (a.pageOrder > b.pageOrder) {
              return 1
            }
            if (b.pageOrder > a.pageOrder) {
              return -1
            } else {
              return 0
            }
          })
        })
      })
      // subsubjectsData.sort((a, b) => a.pageOrder - b.pageOrder)
      state.subsubjectsData = subsubjectsData
    },
    setBoltAllSubsubjectsData (state, payload) {
      const langs = state.langs
      const subsubjectsData = {}

      langs.forEach(lang => {
        subsubjectsData[lang] = []
      })
      payload.forEach(ss => {
        const attrs = ss.attributes
        langs.forEach(lang => {
          const subsubject = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          subsubject.collection_order = attrs.collection_order === '0'
            ? 1000000000
            : attrs.collection_order
          subsubject.id = ss.id
          subsubject.symbolbild = attrs.symbolbild.url
          subsubject.slug = attrs.slug
          subsubject.titel = attrs[`titel${langSuffix}`]
          subsubject.titelNichtVerwenden = attrs.titel_nicht_verwenden
          subsubject.pageOrder = parseInt(attrs.page_order)
          subsubject.kurztext = attrs[`kurztext${langSuffix}`]
          subsubjectsData[lang]
            .push(subsubject)
        })
        langs.forEach(lang => {
          subsubjectsData[lang].sort((a, b) => {
            if (a.pageOrder > b.pageOrder) {
              return 1
            }
            if (b.pageOrder > a.pageOrder) {
              return -1
            } else {
              return 0
            }
          })
        })
      })
      // subsubjectsData.sort((a, b) => a.pageOrder - b.pageOrder)
      // console.log('setBoltAllSubsubjectsData', subsubjectsData)
      state.allSubsubjectsData = subsubjectsData
    },
    setBoltSubjectData (state, payload) {
      const langs = state.langs
      const subjectData = {}

      langs.forEach(lang => {
        subjectData[lang] = {}
      })
      const attrs = payload.attributes

      langs.forEach(lang => {
        const subject = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        subject.symbolbild = attrs.symbolbild.url
        subject.slug = attrs.slug
        subject.einzelthema = attrs.einzelthema
        subject.unterthemenIDs = payload.relationships
        subject.titel = attrs[`titel${langSuffix}`]
        subject.titelNichtVerwenden = attrs.titel_nicht_verwenden
        subject.kurztext = attrs[`kurztext${langSuffix}`]
        subject.thementext = attrs[`thementext${langSuffix}`]
        subjectData[lang] = subject
      })
      state.subjectData = subjectData
      if (state.subjectData.de.unterthemenIDs) {
        state.subSubjectsIDs = state.subjectData.de.unterthemenIDs.map(ut => ut.unterthemen.data[0].id)
        state.boltSubSubjectsEP = this.state.boltApi + 'unterthemen'
        this.dispatch('fetchBoltSubSubjectsData')
      }
    },
    setBoltDossierData (state, payload) {
      const langs = state.langs
      const dossierData = {}
      state.slidersData = {}
      state.mediaObjectsData = {}
      state.dossierData = {}
      state.dossierDataRelDos = {}

      langs.forEach(lang => {
        dossierData[lang] = {}
      })
      const attrs = payload.attributes

      langs.forEach(lang => {
        const dossier = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        dossier.symbolbild = attrs.symbolbild.url
        dossier.symbolbildAusgeben = attrs.symbolbild_ausgeben
        dossier.slug = attrs.slug
        dossier.relationships = payload.relationships
        dossier.mos = dossier.relationships.filter(r => r.medienobjekte)
        dossier.mosIDs = []
        dossier.mos.forEach(mo => {
          dossier.mosIDs.push(mo.medienobjekte.data[0].id)
        })
        dossier.relDos = attrs.related_dossiers
        dossier.titel = attrs[`titel${langSuffix}`]
        dossier.kurztext = attrs[`kurztext${langSuffix}`]
        dossier.thementext = attrs[`text${langSuffix}`]
        dossier.relatedMediaObjects = attrs['related_mediaobjects']
        dossierData[lang] = dossier
      })
      state.dossierData = dossierData
      if (state.dossierData.de.relationships) {
        let mos = []
        let sls = []
        for (let y = 0; y < state.dossierData.de.relationships.length; y++) {
          if (state.dossierData.de.relationships[y].medienobjekte) {
            mos.push(state.dossierData.de.relationships[y].medienobjekte.data[0].id)
          }
          if (state.dossierData.de.relationships[y].slider) {
            sls.push(state.dossierData.de.relationships[y].slider.data[0].id)
          }
        }
        if (mos.length !== 0) {
          state.boltMediaObjectsEP = this.state.boltApi + 'medienobjekte'
          state.mediaObjectsArray = mos
          this.dispatch('fetchBoltMediaObjectsData')
        }
        if (sls.length !== 0) {
          state.slidersArray = sls
          state.boltSlidersEP = this.state.boltApi + 'slider'
          this.dispatch('fetchBoltSlidersData')
        }
      }
    },
    setBoltDossierDataRelDos (state, payload) {
      const langs = state.langs
      langs.forEach(lang => {
        let relDo = {}
        // const langSuffix = lang === 'de' ? '' : `_${lang}`

        relDo.slug = payload.attributes.slug
        if (!state.dossierDataRelDos[lang]) {
          state.dossierDataRelDos[lang] = [relDo]
        } else {
          state.dossierDataRelDos[lang].push(relDo)
        }
      })
    },
    setBoltPublicationData (state, payload) {
      const langs = state.langs
      const publicationData = {}
      state.slidersData = {}
      state.mediaObjectsData = {}

      langs.forEach(lang => {
        publicationData[lang] = {}
      })
      const attrs = payload.attributes

      langs.forEach(lang => {
        const publication = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        publication.cover = attrs.cover.url
        publication.slug = attrs.slug
        publication.pdf = attrs.pdf.url
        publication.relationships = payload.relationships
        publication.rubrik = publication.relationships && publication.relationships[0].db_rubriken
          ? publication.relationships[0].db_rubriken.data[0].id
          : undefined
        publication.kurztitel = attrs[`kurztitel${langSuffix}`]
        publication.verfasser = attrs[`verfasser${langSuffix}`]
        publication.bibliografische = attrs[`bibliografische_angaben${langSuffix}`]
        publication.text = attrs[`text${langSuffix}`]
        publicationData[lang] = publication
      })
      state.publicationData = publicationData
      if (state.publicationData.de.relationships) {
        let mos = []
        let sls = []
        for (let y = 0; y < state.publicationData.de.relationships.length; y++) {
          if (state.publicationData.de.relationships[y].medienobjekte) {
            mos.push(state.publicationData.de.relationships[y].medienobjekte.data[0].id)
          }
          if (state.publicationData.de.relationships[y].slider) {
            sls.push(state.publicationData.de.relationships[y].slider.data[0].id)
          }
        }
        if (mos.length !== 0) {
          state.boltMediaObjectsEP = this.state.boltApi + 'medienobjekte'
          state.mediaObjectsArray = mos
          this.dispatch('fetchBoltMediaObjectsData')
        }
        if (sls.length !== 0) {
          state.slidersArray = sls
          state.boltSlidersEP = this.state.boltApi + 'slider'
          this.dispatch('fetchBoltSlidersData')
        }
      }
    },
    setBoltMediaObjectsData (state, payload) {
      const langs = state.langs
      const mediaObjectsData = {}

      langs.forEach(lang => {
        mediaObjectsData[lang] = []
      })
      payload.forEach(mo => {
        const attrs = mo.attributes
        langs.forEach(lang => {
          const mediaObject = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          mediaObject.page_order = parseInt(attrs.page_order)
          mediaObject.symbolbild = attrs.symbolbild.url
          mediaObject.video_self = attrs.video_self.url
          mediaObject.video_self_high_res = attrs.video_self_high_res.url
          mediaObject.video_platform = attrs.video_platform
          mediaObject.file_pdf = attrs.file_pdf.url
          mediaObject.video_platform = attrs.video_platform
          if (mediaObject.video_platform.url) {
            mediaObject.video_platform_id = mediaObject.video_platform.url.replace('https://player.vimeo.com/video/', '')
            mediaObject.video_platform_id = mediaObject.video_platform.url.replace('https://vimeo.com/', '')
          }
          mediaObject.slug = attrs.slug
          mediaObject.titel = attrs[`titel${langSuffix}`]
          mediaObject.titelNichtVerwenden = attrs.titel_nicht_verwenden
          mediaObject.kurztext = attrs[`kurztext${langSuffix}`]
          mediaObject.text = attrs[`text${langSuffix}`]
          mediaObjectsData[lang].push(mediaObject)
        })
      })
      state.allMediaObjectsData = mediaObjectsData
    },
    setBoltAllMediaObjectsData (state, payload) {
      const langs = state.langs
      const mediaObjectsData = {}

      langs.forEach(lang => {
        mediaObjectsData[lang] = []
      })
      payload.forEach(mo => {
        const attrs = mo.attributes
        langs.forEach(lang => {
          const mediaObject = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`
          const unterthemen = mo.relationships
            ? mo.relationships.filter(r => {
              return r.unterthemen
            })
              .map(u => u.unterthemen.data[0].id)
            : undefined
          mediaObject.page_order = parseInt(attrs.page_order)
          mediaObject.rubrik_sammlung = attrs.rubrik_sammlung
          mediaObject.subs = unterthemen
          mediaObject.id = mo.id
          mediaObject.symbolbild = attrs.symbolbild.url
          mediaObject.video_self = attrs.video_self.url
          mediaObject.video_self_high_res = attrs.video_self_high_res.url
          mediaObject.video_platform = attrs.video_platform
          if (mediaObject.video_platform.url) {
            mediaObject.video_platform_id = mediaObject.video_platform.url.replace('https://player.vimeo.com/video/', '')
          }
          mediaObject.file_pdf = attrs.file_pdf.url
          mediaObject.slug = attrs.slug
          mediaObject.titel = attrs[`titel${langSuffix}`]
          mediaObject.titelNichtVerwenden = attrs.titel_nicht_verwenden
          mediaObject.mehrAnzeigen = attrs.mehr_button
          mediaObject.kurztext = attrs[`kurztext${langSuffix}`]
          mediaObject.text = attrs[`text${langSuffix}`]
          mediaObjectsData[lang].push(mediaObject)
        })
      })
      state.allMediaObjectsData = mediaObjectsData
      state.allMediaObjectsLoaded = true
    },
    setBoltAllLibraryObjectsData (state, payload) {
      const langs = state.langs
      const libraryObjectsData = {}

      langs.forEach(lang => {
        libraryObjectsData[lang] = []
      })
      payload.forEach(lo => {
        const attrs = lo.attributes
        langs.forEach(lang => {
          const libraryObject = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`
          const unterthemen = lo.relationships
            ? lo.relationships.filter(r => {
              return r.unterthemen
            })
              .map(u => u.unterthemen.data[0].id)
            : undefined
          libraryObject.page_order = parseInt(attrs.page_order)
          libraryObject.subs = unterthemen
          libraryObject.id = lo.id
          libraryObject.cover = attrs.cover.url
          libraryObject.coverThumb = attrs.cover
            ? attrs.cover.thumbnail
            : undefined
          libraryObject.file_pdf = attrs.pdf.url
          libraryObject.slug = attrs.slug
          libraryObject.titel = attrs[`kurztitel${langSuffix}`]
          // libraryObject.titelNichtVerwenden = attrs.titel_nicht_verwenden
          // libraryObject.mehrAnzeigen = attrs.mehr_button
          libraryObject.kurztext = attrs[`kurztext${langSuffix}`]
          libraryObject.text = attrs[`text${langSuffix}`]
          libraryObject.verfasser = attrs[`verfasser${langSuffix}`]
          libraryObject.bibliografische_angaben = attrs[`bibliografische_angaben${langSuffix}`]
          libraryObject.rubrik_bibliothek = attrs.rubrik_bibliothek
          libraryObjectsData[lang].push(libraryObject)
        })
      })
      state.allLibraryObjectsData = libraryObjectsData
      state.allLibraryObjectsLoaded = true
    },
    setBoltAllDossiersData (state, payload) {
      const langs = state.langs
      const dossiersData = {}

      langs.forEach(lang => {
        dossiersData[lang] = []
      })

      payload.forEach(dos => {
        const attrs = dos.attributes
        langs.forEach(lang => {
          const dossier = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          dossier.symbolbild = attrs.symbolbild.url
          dossier.slug = attrs.slug
          dossier.relationships = dos.relationships
          dossier.mosIDs = []
          dossier.relDos = attrs.related_dossiers
          dossier.titel = attrs[`titel${langSuffix}`]
          dossier.kurztext = attrs[`kurztext${langSuffix}`]
          dossier.thementext = attrs[`text${langSuffix}`]
          dossier.relatedMediaObjects = attrs['related_mediaobjects']
          if (dossier.relationships) {
            dossier.unterthemen = dossier.relationships.filter(rel => {
              return rel['unterthemen']
            }).map(r => r.unterthemen.data[0].id)
          }
          dossiersData[lang].push(dossier)
        })
      })
      state.dossiersData = dossiersData
      let subSubs = new Set()
      const dossiers = state.dossiersData[state.lang]
        .filter(d => {
          return d.unterthemen
        })
      dossiers.forEach(d => {
        if (d.unterthemen) {
          d.unterthemen.forEach(ut => {
            subSubs.add(ut)
          })
        }
      })
      state.dossiersSubSubs = Array.from(subSubs)
    },
    setBoltSlidersData (state, payload) {
      const langs = state.langs
      const slidersData = {}

      langs.forEach(lang => {
        slidersData[lang] = []
      })
      payload.forEach(sd => {
        const attrs = sd.attributes

        langs.forEach(lang => {
          const slider = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          slider.slug = attrs.slug
          if (attrs.format) {
            if (attrs.format === 'Hochformat') {
              slider.sliderFormat = state.config.sliderFormate.hochformat
            }
            if (attrs.format === 'Buch') {
              slider.sliderFormat = state.config.sliderFormate.buch
            }
            if (attrs.format === 'Querformat') {
              slider.sliderFormat = state.config.sliderFormate.querformat
            }
            if (attrs.format === 'quadratisch') {
              slider.sliderFormat = state.config.sliderFormate.quadratisch
            }
          } else {
            slider.sliderFormat = 1.0
          }
          // aufsplitten nach images
          let imagelist = attrs.imagelist
          let metadatalist = attrs[`metadaten${langSuffix}`]
          let slides = []
          // packe die Metadaten zu jedem Bild
          imagelist.forEach(img => {
            let slide = {}
            slide.sigle = img.title
            slide.url = img.url
            if (metadatalist) {
              metadatalist.forEach(md => {
                if (md.sigle === slide.sigle) {
                  slide.titel = md.titel
                  slide.text = md.text
                }
              })
            }
            slides.push(slide)
          })
          slider.slides = slides
          slidersData[lang].push(slider)
        })
      })
      state.slidersData = slidersData
    },
    setBoltEthnoGroupsData (state, payload) {
      const langs = state.langs
      const ethnoGroupsData = {}

      langs.forEach(lang => {
        ethnoGroupsData[lang] = []
      })
      // noch umstellen auf forEach!
      for (let i = 0; i < payload.length; i++) {
        const attrs = payload[i].attributes

        langs.forEach(lang => {
          const ethnoGroup = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          ethnoGroup.kennnummer = attrs.kennnummer
          ethnoGroup.ethnos = []
          if (payload[i].relationships) {
            for (let u = 0; u < payload[i].relationships.length; u++) {
              let e = {}
              let rel = payload[i].relationships[u]
              e.id = rel.ethnien.data[0].id
              ethnoGroup.ethnos.push(e)
            }
          }
          ethnoGroup.symbolbild = attrs.symbolbild.url
          ethnoGroup.slug = attrs.slug
          ethnoGroup.titel = attrs[`titel${langSuffix}`]
          ethnoGroup.kurztext = attrs[`kurztext${langSuffix}`]
          ethnoGroupsData[lang].push(ethnoGroup)
        })
      }
      state.ethnoGroupsData = ethnoGroupsData
    },
    setBoltDLPageData (state, payload) {
      const langs = state.langs
      const dlPageData = {}

      langs.forEach(lang => {
        dlPageData[lang] = []
      })
      const attrs = payload[0].attributes

      langs.forEach(lang => {
        const dlD = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        dlD.slug = attrs.slug
        dlD.titel = attrs[`title${langSuffix}`]
        dlD.einleitung = attrs[`einleitung${langSuffix}`]
        dlPageData[lang].push(dlD)
      })
      state.dlPageData = dlPageData
    },
    setBoltDLSectionsData (state, payload) {
      const langs = state.langs
      const sectionsData = {}

      langs.forEach(lang => {
        sectionsData[lang] = []
      })
      payload.forEach(dls => {
        const attrs = dls.attributes

        langs.forEach(lang => {
          const section = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`
          section.id = dls.id
          section.symbolbild = attrs.symbolbild.url
          section.slug = attrs.slug
          section.titel = attrs[`titel${langSuffix}`]
          section.kurztext = attrs[`kurztext${langSuffix}`]
          if (dls.relationships) {
            section.publicationIDs = dls.relationships.map(rel => {
              return rel.publikationen.data[0].id
            })
          }
          sectionsData[lang].push(section)
        })
      })
      state.dlSectionsData = sectionsData
    },
    setSingleDLSectionData (state, payload) {
      state.dlSectionData = {}
      state.dlSectionDataPubList = {}
      const langs = state.langs
      const sectionData = {}

      langs.forEach(lang => {
        sectionData[lang] = []
      })
      const attrs = payload.attributes

      langs.forEach(lang => {
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        sectionData[lang].symbolbild = attrs.symbolbild.url
        sectionData[lang].zuordnung = attrs.zuordnung
        sectionData[lang].slug = attrs.slug
        sectionData[lang].rels = payload.relationships
        sectionData[lang].titel = attrs[`titel${langSuffix}`]
        sectionData[lang].kurztext = attrs[`kurztext${langSuffix}`]
      })
      state.dlSectionData = sectionData
      if (state.dlSectionData.de.rels) {
        state.pubIDs = state.dlSectionData.de.rels.map(pub => pub.publikationen.data[0].id)
        state.boltPublicationsEP = this.state.boltApi + 'publikationen'
        this.dispatch('fetchDLSectionPubListData')
      }
    },
    setDLSectionPubList (state, payload) {
      const langs = state.langs
      const pubList = {}
      state.dlSectionDataPubList = {}
      state.dlSectionDataFeaturedPubList = {}

      langs.forEach(lang => {
        pubList[lang] = []
        state.dlSectionDataPubList[lang] = []
        state.dlSectionDataFeaturedPubList[lang] = []
      })
      langs.forEach(lang => {
        payload.forEach(pub => {
          let publication = {}
          const attrs = pub.attributes
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          publication.slug = attrs.slug
          publication.id = pub.id
          publication.datum = attrs.datum
          publication.featured = attrs.featured
          publication.featured_sort = attrs.featured_sort
          publication.zuordnung = attrs.zuordnung
          publication.cover = attrs.cover.url
          publication.kurztitel = attrs[`kurztitel${langSuffix}`]
          publication.verfasser = attrs[`verfasser${langSuffix}`]
          state.dlSectionDataPubList[lang].push(publication)
          if (publication.featured) {
            state.dlSectionDataFeaturedPubList[lang].push(publication)
          }
        })
      })
    },
    setBoltCollectionsPageData (state, payload) {
      const langs = state.langs
      const collectionsPageData = {}

      langs.forEach(lang => {
        collectionsPageData[lang] = []
      })
      const attrs = payload.attributes

      langs.forEach(lang => {
        const collD = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        collD.slug = attrs.slug
        collD.titel = attrs[`title${langSuffix}`]
        collD.einleitung = attrs[`body${langSuffix}`]
        collD.rubriken = attrs[`rubriken${langSuffix}`]
          ? attrs[`rubriken${langSuffix}`].map(r => {
            return {
              titel: r.rubrikentitel,
              text: r.rubrikentext,
              bild: r.rubrikenbild ? r.rubrikenbild.url : undefined,
              link: r.rubrikenlink,
              verbergen: r.verbergen
            }
          })
          : undefined
        collectionsPageData[lang].push(collD)
      })
      state.collectionsPageData = collectionsPageData
    },
    setBoltPagesData (state, payload) {
      const langs = state.langs
      const pagesData = {}

      langs.forEach(lang => {
        pagesData[lang] = []
      })
      payload.forEach(p => {
        const attrs = p.attributes
        langs.forEach(lang => {
          const page = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          page.slug = attrs.slug
          page.titel = attrs[`title${langSuffix}`]
          page.body = attrs[`body${langSuffix}`]
          page.navTitel = attrs[`nav_title${langSuffix}`] ? attrs[`nav_title${langSuffix}`] : page.titel
          pagesData[lang].push(page)
        })
      })
      state.pagesData = pagesData
    },
    // Refactoring: generic version of set Data
    setData (state, payload) {
      const config = state.fetchConfig[payload.forElement]
      const schema = config.schema
      const dataElement = config.data
      const dataConfig = schema
        ? state.schemas[schema]['dataConfig'] 
        : config['dataConfig']
      const langs = state.langs
      const content = {}

      langs.forEach(lang => {
        content[lang] = []
      })
      const attrs = Array.isArray(payload.data)
        ? payload.data[0].attributes
        : payload.data.attributes // bei Seiten
      
      for (let lang of langs) {
        const cont = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`
        for (let field in dataConfig) {
          cont[field] = dataConfig[field]['lang']
            ? attrs[field + langSuffix]
            : attrs[field]
        }
        content[lang].push(cont)
      }    
      state[dataElement] = content
    },
    setBoltAutographsPageData (state, payload) {
      const langs = state.langs
      const autographsPageData = {}

      langs.forEach(lang => {
        autographsPageData[lang] = []
      })
      const attrs = payload.attributes

      langs.forEach(lang => {
        const aPD = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        aPD.slug = attrs.slug
        aPD.titel = attrs[`title${langSuffix}`]
        aPD.body = attrs[`body${langSuffix}`]
        autographsPageData[lang].push(aPD)
      })
      state.autographsPageData = autographsPageData
    },
    setBoltDivDigPageData (state, payload) {
      const langs = state.langs
      const pageData = {}

      langs.forEach(lang => {
        pageData[lang] = []
      })
      const attrs = payload.attributes

      langs.forEach(lang => {
        const pD = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        pD.slug = attrs.slug
        pD.titel = attrs[`title${langSuffix}`]
        pD.body = attrs[`body${langSuffix}`]
        pageData[lang].push(pD)
      })
      state.divDigPageData = pageData
    },
    setBoltFooterData (state, payload) {
      const langs = state.langs
      const footerData = {}

      langs.forEach(lang => {
        footerData[lang] = []
      })
      const attrs = payload

      langs.forEach(lang => {
        const fd = {}
        const langSuffix = lang === 'de' ? '' : `_${lang}`

        fd.titel = attrs[`titel${langSuffix}`]
        fd.logo = attrs.logo.url
        fd.copyright = attrs[`copyright${langSuffix}`]
        fd.spalte_1_titel = attrs[`spalte_1_titel${langSuffix}`]
        fd.spalte_1_text = attrs[`spalte_1_text${langSuffix}`]
        fd.spalte_1_links = attrs[`spalte_1_link${langSuffix}`]
        fd.spalte_2_titel = attrs[`spalte_2_titel${langSuffix}`]
        fd.spalte_2_text = attrs[`spalte_2_text${langSuffix}`]
        fd.spalte_2_links = attrs[`spalte_2_link${langSuffix}`]
        fd.spalte_3_titel = attrs[`spalte_3_titel${langSuffix}`]
        fd.spalte_3_text = attrs[`spalte_3_text${langSuffix}`]
        fd.spalte_3_links = attrs[`spalte_3_link${langSuffix}`]
        fd.spalte_4_titel = attrs[`spalte_4_titel${langSuffix}`]
        fd.spalte_4_text = attrs[`spalte_4_text${langSuffix}`]
        fd.spalte_4_links = attrs[`spalte_4_link${langSuffix}`]
        footerData[lang].push(fd)
      })
      state.footerData = footerData
    },
    setBoltObjectsData (state, payload) {
      const langs = state.langs
      const objectsData = {}

      langs.forEach(lang => {
        objectsData[lang] = []
      })
      payload.forEach(obj => {
        const attrs = obj.attributes
        langs.forEach(lang => {
          const object = {}
          const langSuffix = lang === 'de' ? '' : `_${lang}`

          object.symbolbild = attrs.symbolbild.url
          object.slug = attrs.slug
          object.titel = attrs[`titel${langSuffix}`]
          object.kurztext = attrs[`kurztext${langSuffix}`]
          object.beschreibung = attrs[`beschreibung${langSuffix}`]
          object.objektdaten = attrs[`objektdaten${langSuffix}`]
          object.rels = obj.relationships
          object.moIds = object.rels.filter(r => r.medienobjekte).map(r => r.medienobjekte.data[0].id)
          object.sliderIds = object.rels.filter(r => r.slider).map(r => r.slider.data[0].id)
          object.ethnienIds = object.rels.filter(r => r.ethnien).map(r => r.ethnien.data[0].id)
          objectsData[lang].push(object)
        })
      })
      state.objectsData = objectsData
    },
    switchLanguage (state, payload) {
      state.lang = payload
    },
    setCurrentPage (state, slug) {
      state.currentPage = slug
    },
    setContentParts (state, payload) {
      let partsOut = {}
      let textPartsIn = payload.text_part
      let htmlPartsIn = payload.html_part
      state.langs.forEach(l => {
        let langSuffix = l === 'de' ? '' : `_${l}`
        partsOut[l] = []
        textPartsIn.forEach(tp => {
          let textPart = {}
          textPart.handle = tp.handle
          textPart.text = tp[`text${langSuffix}`]
          textPart.html = '[dies ist ein Text-, kein HTML-Element!]'
          partsOut[l].push(textPart)
        })
        htmlPartsIn.forEach(hp => {
          let htmlPart = {}
          htmlPart.handle = hp.handle
          htmlPart.content = hp[`content${langSuffix}`]
          htmlPart.text = '[dies ist ein HTML-, kein Text-Element!]'
          partsOut[l].push(htmlPart)
        })
      })
      state.contentParts = partsOut
    },
    setCurrentRoute (state, payload) {
      let route = {}
      route.lang = payload.params.lang
      if (payload.path.slice(-3).startsWith('/')) {
        route.main = payload.path.slice(0, -2)
      } else {
        route.main = payload.path + '/'
        route.main.replace('//', '/')
      }
      route.path = route.lang ? route.main + route.lang : route.main + 'de'
      state.currentRoute = route
    },
    setEditMode (state, code) {
      if (state.enableEditCode === code) {
        state.editMode = true
        sessionStorage.setItem('editModeCode', code)
      } else {
        state.enableEditCode = false
      }
    },
    toggleModal (state) {
      state.modalState = !state.modalState
    }
  },
  actions: {
    toggleModal ({ commit }) {
      commit('toggleModal')
    },
    setCurrentPage ({ commit }, slug) {
      commit('setCurrentPage', slug)
    },
    fetchBoltSubSubjectsData ({ commit }) {
      axios.get(this.state.boltSubSubjectsEP, {
        params: {
          'filter[id]': this.state.subSubjectsIDs.toString()
        }
      })
        .then(response => {
          commit('setBoltSubsubjectsData', response.data.data)
        })
    },
    fetchBoltAllSubSubjectsData ({ commit }) {
      axios.get('https://bolt-dev.dh-north.org/json/unterthemen', {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          commit('setBoltAllSubsubjectsData', response.data.data)
        })
    },
    fetchBoltSlidersData ({ commit }) {
      axios.get(this.state.boltSlidersEP, {
        params: {
          'filter[id]': this.state.slidersArray.toString()
        }
      })
        .then(response => {
          commit('setBoltSlidersData', response.data.data)
        })
    },
    fetchBoltMediaObjectsData () {
      axios.get(this.state.boltMediaObjectsEP, {
        params: {
          'filter[id]': this.state.mediaObjectsArray.toString()
        }
      })
        .then(response => {
          this.commit('setBoltMediaObjectsData', response.data.data)
        })
    },
    fetchBoltDossierMediaObjectsData (mos) {
      axios.get(this.state.boltMediaObjectsEP, {
        params: {
          'filter[id]': mos.toString()
        }
      })
        .then(response => {
          this.commit('setBoltDossierMediaObjectsData', response.data.data)
        })
    },
    fetchBoltAllMediaObjectsData () {
      const allMediaObjectsEP = this.state.boltApi + 'medienobjekte'
      axios.get(allMediaObjectsEP, {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          this.commit('setBoltAllMediaObjectsData', response.data.data)
        })
    },
    fetchDLSectionPubListData () {
      axios.get(this.state.boltPublicationsEP, {
        params: {
          'filter[id]': this.state.pubIDs.toString(),
          'sort': '-datum_sort',
          'page[size]': '200'
        }
      })
        .then(response => {
          this.commit('setDLSectionPubList', response.data.data)
        })
    },
    fetchApiData ({ commit }) {
      // Content Parts
      let contentParts = this.state.boltApi + 'content_parts'
      axios.get(contentParts, {
        // params: {        }
      })
        .then(response => {
          commit('setContentParts', response.data.data[0].attributes)
        })
      //  Homepage-Daten
      let boltHome = this.state.boltApi + 'homepage/1'
      axios.get(boltHome, {
        // params: {        }
      })
        .then(response => {
          commit('setBoltHomeData', response.data.data.attributes)
        })
      // Footer
      let boltFooter = this.state.boltApi + 'footer'
      axios.get(boltFooter, {
        // params: {}
      })
        .then(response => {
          commit('setBoltFooterData', response.data.data[0].attributes)
        })
      // Seiten-Daten
      let boltPages = this.state.boltApi + 'seiten'
      axios.get(boltPages, {
        // params: {        }
      })
        .then(response => {
          commit('setBoltPagesData', response.data.data)
        })
      // Themen-Daten
      let boltSubjects = this.state.boltApi + 'themen'
      axios.get(boltSubjects, {
        // params: {        }
      })
        .then(response => {
          commit('setBoltSubjectsData', response.data.data)
        })
      // Ethnien-Daten
      let boltEthnos = this.state.boltApi + 'ethnien'
      axios.get(boltEthnos, {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          commit('setBoltEthnosData', response.data.data)
        })
      // DB-Rubriken
      let boltDLSections = this.state.boltApi + 'db_rubriken'
      axios.get(boltDLSections, {
        // params: {}
      })
        .then(response => {
          commit('setBoltDLSectionsData', response.data.data)
        })
      // Medienobjekte
      const allMediaObjectsEP = this.state.boltApi + 'medienobjekte'
      axios.get(allMediaObjectsEP, {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          this.commit('setBoltAllMediaObjectsData', response.data.data)
        })
      // Bibliotheksobjekte
      const allLibraryObjectsEP = this.state.boltApi + 'bibliotheksobjekte'
      axios.get(allLibraryObjectsEP, {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          this.commit('setBoltAllLibraryObjectsData', response.data.data)
        })
      // Dossiers
      const allDossiersEP = this.state.boltApi + 'dossiers'
      axios.get(allDossiersEP, {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          this.commit('setBoltAllDossiersData', response.data.data)
        })
    },
    fetchApiSingleSubjectData ({ commit }, subject) {
      let boltSubject = this.state.boltApi + 'themen/' + subject
      axios.get(boltSubject, {
        // params: {        }
      })
        .then(response => {
          commit('setBoltSubjectData', response.data.data)
        })
    },
    fetchApiSingleDossierData ({ commit }, dossier) {
      let boltDossier = this.state.boltApi + 'dossiers/' + dossier
      axios.get(boltDossier, {
        // params: {        }
      })
        .then(response => {
          commit('setBoltDossierData', response.data.data)
        })
    },
    fetchApiSinglePublicationData ({ commit }, publication) {
      let boltPublication = this.state.boltApi + 'publikationen/' + publication
      console.log('fetchApiSinglePublicationData, boltPublication', boltPublication)
      axios.get(boltPublication, {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          commit('setBoltPublicationData', response.data.data)
        })
    },
    fetchApiEthnoGroupsData ({ commit }) {
      let boltEthnoGroups = this.state.boltApi + 'ethniengruppen'
      axios.get(boltEthnoGroups, {
        params: {
          'page[size]': '2000'
        }
      })
        .then(response => {
          commit('setBoltEthnoGroupsData', response.data.data)
        })
    },
    fetchApiDLPageData ({ commit }) {
      let boltDL = this.state.boltApi + 'db_seite'
      axios.get(boltDL, {
        // params: {}
      })
        .then(response => {
          commit('setBoltDLPageData', response.data.data)
        })
    },
    fetchApiCollectionsPageData ({ commit }) {
      let boltDL = this.state.boltApi + 'seiten/sammlungen'
      axios.get(boltDL, {
        // params: {}
      })
        .then(response => {
          commit('setBoltCollectionsPageData', response.data.data)
        })
    },
    fetchApiSingleDLSectionData ({ commit }, section) {
      let boltDLSingleSection = this.state.boltApi + 'db_rubriken/' + section
      axios.get(boltDLSingleSection, {
        // params: {}
      })
        .then(response => {
          commit('setSingleDLSectionData', response.data.data)
        })
    },
    // Refactored: generic fetch
    async fetchData ({ commit }, payload) {
      const url = this.state.boltApi + this.state.fetchConfig[payload]['endpoint']
      const response = await axios.get(url)
      commit('setData', {
        data: response.data.data,
        forElement: payload
      })
    },
    fetchApiAllDivDigPageData ({ commit }) {
      let url = this.state.boltApi + 'seiten/weitere-digitale-und-print-materialien'
      axios.get(url, {
        // params: {}
      })
        .then(response => {
          commit('setBoltDivDigPageData', response.data.data)
        })
    },
    fetchBoltDossierRelDos ({ commit }, relDos) {
      // let relDosData = []
      relDos.forEach(relDo => {
        let url = this.state.boltApi + 'dossiers/' + relDo.slug
        axios.get(url, {
          // params: {}
        })
          .then(response => {
            commit('setBoltDossierDataRelDos', response.data.data)
          })
      })
    },
    switchLanguage ({ commit }, lang) {
      commit('switchLanguage', lang)
    },
    setCurrentRoute ({ commit }, payload) {
      commit('setCurrentRoute', payload)
    },
    setEditMode ({ commit }, code) {
      commit('setEditMode', code)
    }
  }
})
